export default "__VITE_ASSET__a0711b23__"